import { Layout } from "react-admin";
import AppBar from "./AppBar";

const AppLayout = (props) => {
    return <Layout {...props} appBar={AppBar} />;
};

export default AppLayout;
